import React, { memo, useCallback } from 'react';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ListItem, ListItemIcon, ListItemText } from '../../material-ui/List';
import { Email } from '../../../icons';
import { getCurrentLeg } from '../../../selectors/screen';
import { useStyles } from '../useStyles';

export const TelegramAdapter = memo(({ value, selected, onClick, className }) => {
    const leg = useSelector(getCurrentLeg) || {};
    const telegramIds = get(leg, 'telegramIds', []);
    const isTelegrams = telegramIds.length > 0;
    const { t: translate } = useTranslation();
    const classes = useStyles();

    const handleClick = useCallback(() => onClick(value), [onClick]);

    return (
        <ListItem onClick={handleClick} button={true} disabled={!isTelegrams} selected={selected}>
            <ListItemIcon className={classes.listIcon}>
                <Email width="24" height="24" />
            </ListItemIcon>
            <ListItemText primary={translate('labels.telegrams')} className={className} />
        </ListItem>
    );
});

TelegramAdapter.displayName = 'TelegramAdapter';
